import { TCaseComment } from "@/api/entities/case-comment.entity";
import { MONTH_DATE_FORMAT_WITH_TIMES } from "@/constants/datetime";
import { UiComment } from "@/features/case/types/caseCommentForm";
import dayjs from "dayjs";

export const transformComments = (apiData: TCaseComment[] = [], currentUserId: number): UiComment[] => {
  return apiData
    .filter((item) => item && item.content)
    .map((item) => ({
      id: item.id,
      name: item.user?.fullName || "",
      text: item.content || "",
      time: item.createdAt ? dayjs(item.createdAt).format(MONTH_DATE_FORMAT_WITH_TIMES) : "",
      isOwn: Number(item.userId) === currentUserId,
    }));
};
